import Vue from 'vue';
import Vuex from 'vuex';
import AuthStore from '@/store/modules/auth';
import DevicesStore from '@/store/modules/devices';
import LoadStore from '@/store/modules/load';
import MessageStore from '@/store/modules/message';
import PreferencesStore from '@/store/modules/preferences';
import TenantsStore from '@/store/modules/tenants';

import devicesWebsocketPlugin from '@/store/plugins/devicesWebsocket';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [devicesWebsocketPlugin],

  modules: {
    auth: AuthStore,
    devices: DevicesStore,
    load: LoadStore,
    msg: MessageStore,
    preferences: PreferencesStore,
    tenants: TenantsStore,
  },
});
